<ng-container *transloco="let tr; prefix: 'productDefinitions.media'; scope: 'product-definitions'">
  <div class="dlg">
    <div class="body">
      <div class="stagebox">
        <div class="stage">
          <div class="orig" [style.width.px]="stageW" [style.height.px]="stageH" (pointerdown)="onPointerDown($event)" (pointermove)="onPointerMove($event)" (pointerup)="onPointerUp()" (pointercancel)="onPointerUp()" (wheel)="onWheel($event)">
            @if (stageSrc()) {
              <img class="pic" [src]="stageSrc()" [style.width]="stageLayer().width" [style.left]="stageLayer().left" [style.top]="stageLayer().top" alt="" draggable="false" />
            } @else if (loadFailed()) {
              <span class="stage-note">{{ tr('frame.loadFailed') }}</span>
            } @else {
              <span class="stage-note"><span class="spin" aria-hidden="true"></span></span>
            }
            <div class="frame" tabindex="0" role="application" [attr.aria-label]="tr('frame.stageAria')" [style.left.px]="frameBox().left" [style.top.px]="frameBox().top" [style.width.px]="frameBox().width" [style.height.px]="frameBox().height" (keydown)="onKey($event)">
              <i class="v1"></i><i class="v2"></i><i class="h1"></i><i class="h2"></i>
              <b class="c tl"></b><b class="c tr"></b><b class="c bl"></b><b class="c br"></b>
            </div>
          </div>
        </div>
        <label class="ctl"><span>{{ tr('frame.zoom') }}</span><input type="range" min="100" step="5" [max]="maxZoomPercent" [value]="zoom()" [disabled]="saving() || maxZoomPercent <= 100" [attr.aria-label]="tr('frame.zoom')" (input)="onZoom($event)" /><span class="val">{{ zoom() }} %</span></label>
        <label class="ctl"><span>{{ tr('frame.horizontal') }}</span><input type="range" min="0" max="100" [value]="offsetX()" [disabled]="saving()" [attr.aria-label]="tr('frame.horizontal')" (input)="onOffset('x', $event)" /><span class="val"></span></label>
        <label class="ctl"><span>{{ tr('frame.vertical') }}</span><input type="range" min="0" max="100" [value]="offsetY()" [disabled]="saving()" [attr.aria-label]="tr('frame.vertical')" (input)="onOffset('y', $event)" /><span class="val"></span></label>
      </div>

      <div class="side">
        <span class="lbl">{{ tr('frame.original') }} {{ original() }}@if (isVideo) { — {{ tr('frame.originalVideoNote') }} }</span>
        <div class="previews">
          <div class="pv">
            <span class="lbl">{{ tr('frame.pagePreview') }}</span>
            <div class="pbox page">
              @if (stageSrc()) {
                <img class="pic" [src]="stageSrc()" [style.width]="pageLayer().width" [style.left]="pageLayer().left" [style.top]="pageLayer().top" alt="" />
              }
              @if (isVideo) {
                <span class="pplay" aria-hidden="true"><hc-media-icon name="play" [size]="20"></hc-media-icon></span>
              }
            </div>
          </div>
          <div class="pv">
            <span class="lbl">{{ tr('frame.catalogPreview') }}</span>
            <div class="pbox catalog">
              @if (stageSrc()) {
                <img class="pic" [src]="stageSrc()" [style.width]="pageLayer().width" [style.left]="pageLayer().left" [style.top]="pageLayer().top" alt="" />
              }
            </div>
          </div>
          <div class="pv">
            <span class="lbl">{{ tr('frame.cartPreview') }}</span>
            <div class="pbox cart">
              @if (stageSrc()) {
                <img class="pic" [src]="stageSrc()" [style.width]="pageLayer().width" [style.left]="pageLayer().left" [style.top]="pageLayer().top" alt="" />
              }
            </div>
          </div>
        </div>

        @if (problem(); as p) {
          <div class="alert err"><hc-media-icon name="info" [size]="16"></hc-media-icon><span class="alert-body"><b>{{ tr('frame.problem.title') }}</b><span>{{ tr('frame.problem.' + p) }}</span></span></div>
        } @else {
          <div class="alert" [class.ok]="output().level === 'ok'" [class.warn]="output().level === 'warn'">
            <hc-media-icon [name]="output().level === 'ok' ? 'ok' : 'info'" [size]="16"></hc-media-icon>
            <span class="alert-body">
              @if (isVideo) {
                @if (output().level === 'ok') {
                  <b>{{ tr('frame.out.video.okTitle', { w1080: 1080, h1080: 1158, w720: 720, h720: 772 }) }}</b>
                  <span>{{ tr('frame.out.video.okText', { second: secondText(), widths: coverWidthsText() }) }}</span>
                } @else {
                  <b>{{ tr('frame.out.video.warnTitle', { cropW: crop().w, w: smallest(), h: smallestH() }) }}</b>
                  <span>{{ tr('frame.out.video.warnText', { second: secondText() }) }}</span>
                }
              } @else {
                @if (output().level === 'ok') {
                  <b>{{ tr('frame.out.photo.okTitle', { outW: output().outW, outH: output().outH }) }}</b>
                  <span>{{ tr('frame.out.photo.okText', { widths: widthsText() }) }}</span>
                } @else {
                  <b>{{ tr('frame.out.photo.warnTitle', { cropW: crop().w }) }}</b>
                  <span>{{ tr('frame.out.photo.warnText') }}</span>
                }
              }
            </span>
          </div>
        }

        @if (isVideo) {
          <div class="cover">
            <label class="ctl"><span>{{ tr('frame.cover') }}</span><input type="range" min="0" step="1" [max]="lastSec" [value]="second()" [disabled]="saving() || lastSec === 0" [attr.aria-label]="tr('frame.cover')" (input)="onSecond($event)" /><span class="val">{{ secondText() }}</span></label>
            <div class="strip">
              @for (c of cells(); track c.sec) {
                <button type="button" class="cell" [class.on]="c.active" [attr.aria-label]="tr('frame.coverAt', { second: c.text })" [disabled]="saving()" (click)="pickSecond(c.sec)">
                  @if (c.style && stripSrc()) {
                    <img class="cell-pic" [src]="stripSrc()" [style.width]="c.style.width" [style.left]="c.style.left" [style.transform]="c.style.transform" alt="" draggable="false" />
                  }
                </button>
              }
            </div>
            <span class="help">{{ tr('frame.coverHelp') }}</span>
          </div>
        }

        <div class="alert gray">
          <span class="cmp">
            @if (stageSrc()) {
              <img class="pic" [src]="stageSrc()" [style.width]="pageLayer().width" [style.left]="pageLayer().left" [style.top]="pageLayer().top" alt="" />
            }
          </span>
          <span>{{ isVideo ? tr('frame.compare.VIDEO') : tr('frame.compare.PHOTO') }}</span>
        </div>

        <span class="help">{{ tr('frame.hint') }}</span>
      </div>
    </div>

    @if (error()) {
      <div class="alert err save-error"><hc-media-icon name="info" [size]="16"></hc-media-icon><span>{{ error() }}</span></div>
    }

    <div class="foot">
      <button nz-button type="button" [disabled]="saving()" (click)="reset()">{{ tr('frame.reset') }}</button>
      <span class="grow"></span>
      <button nz-button type="button" [disabled]="saving()" (click)="close()">{{ tr('frame.cancel') }}</button>
      <button nz-button nzType="primary" type="button" [nzLoading]="saving()" [disabled]="saving() || !!problem()" (click)="save()">{{ tr('frame.save.' + item.type) }}</button>
    </div>
  </div>
</ng-container>
